module.exports = __webpack_public_path__ + "assets/images/18-3Tx85RK.jpg";